export default __webpack_public_path__ + "static/media/default_white@3x.365c5eb9.jpg";